import { RESTFUL } from '@/data/constants';

/**
 * Get options list by type
 */
export async function getOptions(api, params = {}) {
  const { data } = await api.get(RESTFUL.options.list, { params });
  return data;
}

/**
 * Get single option by ID
 */
export async function getOption(api, id) {
  const { data } = await api.get(`${RESTFUL.options.read}/${id}`);
  return data;
}

/**
 * Create new option
 */
export async function createOption(api, payload) {
  const { data } = await api.post(RESTFUL.options.create, payload);
  return data;
}

/**
 * Update option
 */
export async function updateOption(api, id, payload) {
  const { data } = await api.patch(`${RESTFUL.options.update}/${id}`, payload);
  return data;
}

/**
 * Delete option
 */
export async function deleteOption(api, id) {
  const { data } = await api.delete(`${RESTFUL.options.delete}/${id}`);
  return data;
}

/**
 * Bulk update options order
 */
export async function updateOptionsOrder(api, options) {
  const promises = options.map((option, index) => updateOption(api, option._id, { order: index }));
  return await Promise.all(promises);
}

/**
 * Update subType name and order
 */
export async function updateSubType(api, payload) {
  const { data } = await api.patch(`${RESTFUL.options.update}/subtype`, payload);
  return data;
}
